<template>
  <el-dialog width="1000px" top="6vh" @open="open">
    <div class="send-dialog">
      <div class="send-dialog__title">发货</div>
      <div class="send-dialog__content">
        <lida-table
          ref="table"
          :pagination="false"
          :height="300"
          :data="data"
          border
          @selection-change="selectGoods"
        >
          <el-table-column :selectable="checkSelectable" type="selection" width="55" fixed />
          <lida-table-column label="产品信息" fixed>
            <template #default="scope">
              <div class="goods-info">
                <div class="goods-info__image">
                  <img :src="scope.row.src" />
                </div>
                <div class="goods-info__main">
                  <div class="goods-info__title">
                    {{ scope.row.productName }}
                    <div class="goods-info__brand" :title="scope.row.brandName">{{ scope.row.brandName }}</div>
                  </div>
                  <div class="goods-info__meta">
                    {{ scope.row.barCode || '--' }}
                    <span>|</span>
                    {{ scope.row.seriesName || '--' }}
                    <span>|</span>
                    {{ scope.row.skuNumber || '--' }}
                  </div>
                </div>
              </div>
            </template>
          </lida-table-column>
          <lida-table-column label="订货号" prop="articleNo" />
          <lida-table-column label="采购数量" :min-width="80" prop="purchaseQty" />
          <lida-table-column label="采购单价" :min-width="80" prop="purchasePrice" />
          <lida-table-column label="备注" :min-width="150" prop="remarks" />
          <lida-table-column label="发货数量">
            <template #default="scope">
              <el-input-number
                v-model="scope.row.num"
                :min="scope.row.weiNum >= 1 ? 1 : 0"
                :max="scope.row.weiNum"
                @change="handleChange"
                :disabled="!scope.row.weiNum"
              />
            </template>
          </lida-table-column>
          <lida-table-column label="未发货数量" prop="weiNum" fixed="right" />
        </lida-table>

        <div class="send-dialog__bottom">
          <div class="send-dialog__left">
            <div class="form-item">
              <span><i>*</i>快递公司</span>
              <el-select v-model="obj.courierCompany" style="flex: 1" filterable placeholder="请选择快递公司">
                <el-option
                  v-for="item in courierCompany"
                  :key="item.type"
                  :label="item.title"
                  :value="item.type"
                />
              </el-select>
            </div>

            <div class="form-item" v-if="obj.courierCompany === 'shunfeng'">
              <span><i>*</i>手机号</span>
              <el-input v-model="obj.courierPhone" style="flex: 1" placeholder="请输入手机号" />
            </div>

            <div class="form-item">
              <span><i>*</i>快递单号</span>
              <el-input v-model="obj.courierNumber" style="flex: 1" placeholder="请输入快递单号" />
            </div>

            <div class="form-item">
              <span><i>*</i>发货城市</span>
              <el-cascader
                v-model="obj.area"
                style="flex: 1"
                :options="areaOptions"
                :props="{ expandTrigger: 'hover' }"
                placeholder="请选择发货城市"
                clearable
              />
            </div>

            <div class="form-item">
              <span>备注</span>
              <el-input
                v-model="obj.remarks"
                :rows="4"
                type="textarea"
                placeholder="请输入备注"
                style="flex: 1"
              />
            </div>
          </div>

          <div class="send-dialog__right">
            <div class="form-item">
              <span><i>*</i>装箱照</span>
              <upload-file
                v-model="obj.fileIds"
                class="ship-upload"
                isType="drag"
                list-type="picture-card"
                :limit="5"
                :list="fileList"
                onlyImage
                accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                :maxSizeMb="2"
                @usuccess="handleUploadSuccess"
                @delete="handleUploadDelete"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="send-dialog__footer">
        <el-button size="mini" @click="close">取消</el-button>
        <el-button size="mini" type="primary" @click="confirm">确认</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { ElMessage } from 'element-plus';
import uploadFile from '@/components/publicComponent/uploadFile.vue';
import area from '@/common/json/area.json';
import { handleTreeData, runNumber } from '@/common/js/common.js';

const createFormData = () => ({
  courierNumber: '',
  remarks: '',
  fileIds: [],
  courierCompany: '',
  courierPhone: '',
  area: []
});

export default {
  components: {
    uploadFile
  },
  props: {
    orderInfo: {
      type: Array,
      default: () => []
    },
    oid: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      areaOptions: handleTreeData(area, 'name', 'name'),
      data: [],
      obj: createFormData(),
      fileList: []
    };
  },
  computed: {
    ...mapState('purchaseMudule', ['courierCompany'])
  },
  methods: {
    ...mapActions('mysaleMudule', ['purchaseList', 'purchasePurchaseShip']),
    close() {
      this.$emit('update:modelValue', false);
    },
    open() {
      this.getList();
    },
    getList() {
      this.purchaseList(this.oid).then(res => {
        const { code, data = [] } = res.data || {};
        if (code === '0') {
          this.data = data.map(item => {
            const weiNum = Math.max(runNumber(item.purchaseQty) - runNumber(item.shipQty), 0);
            return {
              ...item,
              weiNum,
              num: weiNum >= 1 ? 1 : 0
            };
          });
        }
      });
    },
    checkSelectable(row) {
      return !!row.weiNum;
    },
    selectGoods(selected) {
      this.data.forEach(item => {
        item.active = selected.some(v => v.skuId === item.skuId);
      });
    },
    handleChange() {},
    getFileIds(list = []) {
      return list
        .map(item => item.fileId || (item.data && item.data.fileId) || (item.response && item.response.data && item.response.data.fileId))
        .filter(Boolean);
    },
    handleUploadSuccess(info, fileList) {
      this.fileList = [...fileList];
      this.obj.fileIds = this.getFileIds(fileList);
    },
    handleUploadDelete(fileList) {
      this.fileList = [...fileList];
      this.obj.fileIds = this.getFileIds(fileList);
    },
    confirm() {
      const goods = this.data.filter(v => v.active && v.num).map(item => ({ skuId: item.skuId, shipQty: item.num }));
      if (!goods.length) {
        ElMessage({ type: 'warning', message: '请选择发货商品' });
        return;
      }
      if (!this.obj.courierNumber) {
        ElMessage({ type: 'warning', message: '请输入快递单号' });
        return;
      }
      if (!this.obj.courierCompany) {
        ElMessage({ type: 'warning', message: '请选择快递公司' });
        return;
      }
      if (this.obj.courierCompany === 'shunfeng' && !this.obj.courierPhone) {
        ElMessage({ type: 'warning', message: '请输入手机号' });
        return;
      }
      if (!this.obj.area || !this.obj.area.length) {
        ElMessage({ type: 'warning', message: '请选择发货城市' });
        return;
      }
      if (!this.obj.fileIds || !this.obj.fileIds.length) {
        ElMessage({ type: 'warning', message: '请上传发货装箱照' });
        return;
      }

      const payload = {
        ...this.obj,
        courierPhone: this.obj.courierCompany === 'shunfeng' ? this.obj.courierPhone : '',
        province: this.obj.area[0] || '',
        city: this.obj.area[1] || '',
        district: this.obj.area[2] || '',
        documentId: this.oid,
        shipItemList: goods
      };
      delete payload.area;

      this.purchasePurchaseShip(payload).then(res => {
        const { code } = res.data || {};
        if (code === '0') {
          ElMessage({ type: 'success', message: '发货成功' });
          this.$emit('success');
          this.clearData();
          this.close();
        }
      });
    },
    clearData() {
      this.data = [];
      this.obj = createFormData();
      this.fileList = [];
    }
  }
};
</script>

<style scoped lang="less">
.ship-upload {
  :deep(.el-upload-dragger) {
    width: 148px;
    height: 148px;
    padding: 16px 8px;
    box-sizing: border-box;
    border: none;
    background: transparent;
    line-height: normal;
  }
  :deep(.el-upload-dragger.is-dragover) {
    background: #e5f3f2;
  }
  :deep(.icon-yunshangchuan) {
    margin-top: 0;
    font-size: 36px;
  }
  :deep(.el-upload__text) {
    margin-top: 8px;
    line-height: 20px;
  }
  :deep(.el-upload__tip) {
    display: none;
  }
}

.send-dialog {
  font-size: 14px;
  padding: 20px;

  &__title {
    font-weight: bold;
    padding: 0 20px 20px 0;
  }

  &__footer {
    display: flex;
    justify-content: center;
    gap: 40px;
    padding-top: 20px;
  }

  &__bottom {
    display: flex;
    justify-content: space-between;
  }

  &__left {
    flex: 2;
  }

  &__right {
    margin-left: 20px;
  }
}

.form-item {
  display: flex;
  padding-top: 20px;

  span {
    white-space: nowrap;
    width: 70px;
    text-align: right;
    margin-right: 20px;
    line-height: 40px;

    i {
      color: #d84146;
      margin-right: 5px;
    }
  }
}

.goods-info {
  display: flex;
  align-items: center;

  &__image {
    width: 52px;
    height: 52px;
    margin-right: 12px;
    border-radius: 8px;
    overflow: hidden;
    background: #f8f8f8;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &__main {
    min-width: 0;
  }

  &__title {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 6px;
  }

  &__brand {
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 2px 8px;
    border-radius: 10px;
    background: #f4f7f9;
    color: #606266;
    font-size: 12px;
  }

  &__meta {
    color: #909399;
    font-size: 12px;

    span {
      margin: 0 6px;
    }
  }
}
</style>
